// src/storeAPIs/StoreProductsAPIs.js
import apiClient from "../utils/Http";

// ===== BASIC CRUD OPERATIONS =====
export const storeGetAllProducts = (params = {}) =>
  apiClient.get("api/store/products/", { params });

export const storeGetProductBySlug = (slug) =>
  apiClient.get(`api/store/products/${slug}/`);

export const storeCreateProduct = (data) => {
  const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
  return isFormData
    ? apiClient.post("api/store/products/", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    : apiClient.post("api/store/products/", data);
};

export const storeUpdateProduct = (slug, data) => {
  const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
  return isFormData
    ? apiClient.patch(`api/store/products/${slug}/`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    : apiClient.put(`api/store/products/${slug}/`, data);
};

export const storePatchProduct = (slug, data) =>
  apiClient.patch(`api/store/products/${slug}/`, data);

export const storeDeleteProduct = (slug) =>
  apiClient.delete(`api/store/products/${slug}/`);

// ===== FILTERING =====
export const storeGetProductsByCategory = (categorySlug, params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, category: categorySlug },
  });

export const storeGetProductsInCategoryExact = (categorySlug, params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, category_exact: categorySlug },
  });

export const storeGetProductsByCategoryId = (categoryId, params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, category_id: categoryId },
  });

export const storeGetProductsInPriceRange = (minPrice, maxPrice, params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, min_price: minPrice, max_price: maxPrice },
  });

export const storeGetInStockProducts = (params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, in_stock: true },
  });

// ===== SEARCH =====
export const storeSearchProducts = (query, params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, search: query },
  });

// ===== ORDERING =====
export const storeGetProductsOrderedByPrice = (direction = "asc", params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, ordering: direction === "asc" ? "price" : "-price" },
  });

export const storeGetProductsOrderedByNewest = (params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, ordering: "-created_at" },
  });

// ===== PAGINATION =====
export const storeGetProductsPage = (page = 1, pageSize = 20, params = {}) =>
  apiClient.get("api/store/products/", {
    params: { ...params, page, page_size: pageSize },
  });